import styled from '@emotion/styled';
import {css, Theme} from '@emotion/react';

const styledSection = ({theme}: {theme: Theme}) => css`
  display: flex;
  flex-direction: column;
  gap: ${theme.gap.desktop.xl};

  // Mobile
  @media screen and (max-width: ${theme.screenBreakpoint.md.px}) {
    gap: ${theme.gap.desktop.lg};
  }
`;

export const SectionLoansDesktopWrapper = styled.div`
  ${styledSection};
  padding: ${({theme}) => theme.padding.desktop.md};
`;

export const SectionLoansMobileWrapper = styled.div`
  ${styledSection};
`;
